import React, { useContext } from "react";
import * as CONST from "../../helpers/Constants";
import { Settings } from "../../helpers/Contexts";
import FieldError from "../../shared/FieldError";

const KidneyFunctionTestSubForm = (props) => {
  const [showKidneyFunctionTests, setShowKidneyFunctionTests] = React.useState(false);
  const [kidneyFunctionInputText, setKidneyFunctionInputText] = React.useState(null);
  const [selectedKidneyFunctionTest, setSelectedKidneyFunctionTest] = React.useState("");
  let values = props.values;
  const settings = useContext(Settings);
  let setFieldValue = props.setFieldValue;
  return (
    <>
      <label>Kidney Function Test</label>
      <select
        className="time-selector"
        placeholder="Select procedure type"
        name="procedure_type"
        onChange={(e) => {

          // For Kidney Function Tests, the KidneyFunctionTestSubForm allows up to two values to be submitted.
          // For example, we submit a Urine Protein Screening with a Kidney Function Test (EGFR),
          // or a Kidney Function Test (Microalbumin/Creatinine Ratio) with a Kidney Function Test (EGFR).
          // We store the possible combinations of kidney function tests in CONST.KIDNEY_FUNCTION_TEST_COMBOS
          let kft = CONST.KIDNEY_FUNCTION_TEST_COMBOS.filter((i) => i.label == e.target.value)[0];

          let qmtIds = kft.quality_measurement_types.map((qmtName) => {
            return settings.kidney_function_test_options.find((el) => el.label == qmtName).quality_measurement_type_id;
          });

          // We set two quality_measurement_type_ids.
          setFieldValue("quality_measurement_type_id", qmtIds[0]);
          if (qmtIds.length == 2) {
            setFieldValue("quality_measurement_type_id_2",qmtIds[1]);
          }

          setFieldValue("procedure_type", e.target.value);
          setFieldValue("attending_provider", "");
          setSelectedKidneyFunctionTest(e.target.value);
          setFieldValue("value", true);

          if (['Urine Protein Screening + Kidney Function Test (eGFR)',
            'Kidney Function Test (Microalbumin/Creatinine Ratio) + eGFR'].includes(e.target.value)) {
            setShowKidneyFunctionTests(true);
          } else {
            setShowKidneyFunctionTests(false);
          }

          setKidneyFunctionInputText(e.target.value);

        }}
      >
        {!values.quality_measurement_type_id && (
          <option value={""}>Select procedure type</option>
        )}
        {CONST.KIDNEY_FUNCTION_TEST_COMBOS.map((t, idx) => (
          <option key={idx} value={t.label}>
            {t.label}
          </option>
        ))}
      </select>
      {
        kidneyFunctionInputText == 'Kidney Function Test (Microalbumin/Creatinine Ratio) + eGFR' && (
          <>
            <label>Kidney Function Test (Microalbumin/Creatinine Ratio)</label>
            <input
              className="default"
              name="value"
              required={true}
              onChange={(e) => {
                setFieldValue("value", e.target.value)
              }}
            />
          </>
        )
      }

      {
        kidneyFunctionInputText == 'Urine Protein Screening + Kidney Function Test (eGFR)' && (
          <>
            <label>Urine Protein Screening</label>
            <input
              className="default"
              name="value"
              required={true}
              onChange={(e) => {
                setFieldValue("value", e.target.value)
              }}
            />
          </>
        )
      }
      {
        showKidneyFunctionTests && (
          <>
            <label>Kidney Function Test (eGFR)</label>
            <input
              className="default"
              name="value"
              required={true}
              onChange={(e) => {
                setFieldValue("value_2", e.target.value)
              }}
            />
          </>
        )
      }
    </>
  );
};

export default KidneyFunctionTestSubForm;
